import { motion } from 'framer-motion';
import { FileSpreadsheet, Zap, Layout, Cpu, Code } from 'lucide-react';

const services = [
    {
        icon: FileSpreadsheet,
        title: 'Spreadsheet Automation',
        description: "I'll automate your Google Sheets so data flows automatically to Sheets, Documents, Slides, and external applications like QuickBooks, SquareUp, Asana, DocuSign, and much more.",
    },
    {
        icon: Layout,
        title: 'Custom Dashboards',
        description: "See your business data at a glance. I build simple, powerful dashboards your team will actually use.",
    },
    {
        icon: Cpu,
        title: 'AI Integration',
        description: "Add intelligence to your workflows. Data enrichment, smart categorization, and decision support.",
    },
    {
        icon: Code,
        title: 'Custom Internal Tools',
        description: "I'll build custom internal tools for you that will be completed hosted on Spreadsheet but will be tailor fit to your use case.",
    }
];

export const Services = () => {
    return (
        <section id="services" className="py-20 md:py-28 bg-[#FAFAFA]" data-testid="services-section">
            <div className="max-w-6xl mx-auto px-6 md:px-12">
                {/* Section Header */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5 }}
                    className="text-center mb-16"
                >
                    <p className="text-[#34A853] text-sm font-medium uppercase tracking-widest mb-4">
                        What I Do
                    </p>
                    <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#2C2C2C] mb-4">
                        Simple Solutions, Real Results
                    </h2>
                    <p className="text-[#6B6B6B] text-lg max-w-2xl mx-auto">
                        Most business owners don't realize how much can be automated. I help you discover what's possible - the most common feedback I get is <span className="italic text-[#2C2C2C]">"I should have done this sooner."</span>
                    </p>
                </motion.div>

                {/* Services Grid */}
                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {services.map((service, index) => (
                        <motion.div
                            key={service.title}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                            className="bg-white p-6 rounded-2xl border border-[#E5E5E5] hover:border-[#34A853]/50 hover:shadow-card transition-all duration-300"
                            data-testid={`service-card-${index}`}
                        >
                            <div className="w-12 h-12 rounded-xl bg-[#E8F5E9] flex items-center justify-center mb-5">
                                <service.icon size={24} className="text-[#34A853]" />
                            </div>
                            
                            <h3 className="font-semibold text-lg text-[#2C2C2C] mb-2">
                                {service.title}
                            </h3>
                            
                            <p className="text-[#6B6B6B] text-sm leading-relaxed">
                                {service.description}
                            </p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};
